export const GET_LIST_PHIKHACHANGKY = "GET_LIST_PHIKHACHANGKY";
export const GET_LIST_PHIKHACHANGKY_SUCCESS = "GET_LIST_PHIKHACHANGKY_SUCCESS";
export const GET_LIST_PHIKHACHANGKY_FAILURE = "GET_LIST_PHIKHACHANGKY_FAILURE";
export const GET_LIST_PHIKHACHANGKY_CHOVAY = "GET_LIST_PHIKHACHANGKY_CHOVAY";
export const GET_LIST_PHIKHACHANGKY_CHOVAY_SUCCESS = "GET_LIST_PHIKHACHANGKY_CHOVAY_SUCCESS";
export const GET_LIST_PHIKHACHANGKY_CHOVAY_FAILURE = "GET_LIST_PHIKHACHANGKY_CHOVAY_FAILURE";
